module.exports = __webpack_public_path__ + "static/media/Vit_logo.6a026305.jpeg";